// FILE: DeleteAccount.js
import React from 'react';
import './PageStyles.css';

function DeleteAccount() {
  return (
    <div className="page">
      <h1 className="brand">Delete Your Test Yodha Account</h1>
      <p>
        We’re sorry to see you go. To delete your Test Yodha account and all related data,
        please follow the steps below:
      </p>

      <ol className="delete-list">
        <li>Send us an email using the button below from your registered email address.</li>
        <li>Use the subject line: <strong>"Delete My Account"</strong>.</li>
        <li>Mention your full name and phone number (optional for verification).</li>
      </ol>

      <a href="mailto:testyodha3@gmail.com?subject=Delete%20My%20Account" className="delete-button">
        Request Account Deletion
      </a>

      <p className="note">
        Your request will be verified and your data will be deleted within 7 working days.
      </p>
    </div>
  );
}

export default DeleteAccount;
